export interface ParametroDefinicao {
  id: number | null; // null para o caso do "ano"
  label: string;
  defaultName: string;
  defaultDefinition?: string; // Opcional, para preencher a descrição/prompt
}

export const CATALOGO_PARAMETROS: ParametroDefinicao[] = [
  // --- JÁ EXISTENTES ---
  { id: 1, label: "Ativo Total", defaultName: "ativo" },
  { id: 2, label: "Ativo Circulante", defaultName: "ativo_circulante" },
  { id: 3, label: "Disponível (Caixa e Equivalentes)", defaultName: "disponivel_caixa" },
  { id: 4, label: "Aplicações Financeiras", defaultName: "aplicacoes_financeiras" },
  { id: 5, label: "Ativo Não Circulante", defaultName: "ativo_nao_circulante" },
  { id: 7, label: "Passivo Circulante", defaultName: "passivo_circulante" },
  { id: 8, label: "Instituições Financeiras (Curto Prazo)", defaultName: "instituicoes_financeiras" },
  { id: 9, label: "Passivo Não Circulante", defaultName: "passivo_nao_circulante" },
  { id: 11, label: "Patrimônio Líquido", defaultName: "patrimonio_liquido" },
  { id: 12, label: "Resultado", defaultName: "resultado" },
  { id: 15, label: "Resultado Financeiro", defaultName: "resultado_financeiro" },
  { id: 17, label: "Despesas Financeiras", defaultName: "despesas_financeiras" },
  { id: 25, label: "Resultado EBIT", defaultName: "resultado_ebit" },
  { id: 70, label: "Depreciação e Amortização", defaultName: "depreciacao_amortizacao" },
  { id: 73, label: "Estoque", defaultName: "estoque" },
  { id: 89, label: "Custos", defaultName: "custos" },
  { id: 97, label: "Receita Líquida", defaultName: "receita_liquida" },

  // --- NOVOS ITENS MAPEADOS DO ENUM ---
  { id: 6, label: "Passivo Total", defaultName: "passivo" },
  { id: 10, label: "Inst. Financeiras (Longo Prazo)", defaultName: "passivo_nao_circulante_instituicao_financeira" },
  { id: 13, label: "Receita Operacional Líquida", defaultName: "resultado_receita_operacional_liquida" },
  { id: 14, label: "Res. Operacional Antes Res. Financeiro", defaultName: "resultado_operacional_antes_resultado_financeiro" },
  { id: 16, label: "Receitas Financeiras (Res. Fin.)", defaultName: "resultado_financeiro_receita_financeira" },
  { id: 18, label: "Resultado Antes IR/CSLL", defaultName: "resultado_antes_imposto_renda_csll" },
  { id: 19, label: "Tributos", defaultName: "resultado_tributos" },
  { id: 20, label: "IRPJ e CSLL", defaultName: "resultado_irpj_csll" },
  { id: 21, label: "Despesa Tributária", defaultName: "resultado_despesa_tributaria" },
  { id: 22, label: "Receita", defaultName: "receita" },
  { id: 23, label: "Custo", defaultName: "custo" },
  { id: 24, label: "Capital Social", defaultName: "capital_social" },
  { id: 26, label: "Lucro Antes IRPJ", defaultName: "resultado_lucro_antes_irpj" },
  { id: 27, label: "Liquidez Corrente", defaultName: "liquidez_corrente" },
  { id: 28, label: "Endividamento Geral", defaultName: "endividamento_geral" },
  { id: 29, label: "Dívida Bancária", defaultName: "divida_bancaria" },
  { id: 30, label: "Cobertura Dívida", defaultName: "cobertura_divida" },
  { id: 31, label: "Caixa Bancos", defaultName: "caixa_bancos" },
  { id: 32, label: "ROIC", defaultName: "roic" },
  { id: 33, label: "Liquidez Curto Prazo", defaultName: "liquidez_curto_prazo" },
  { id: 34, label: "Liquidez Longo Prazo", defaultName: "liquidez_longo_prazo" },
  { id: 35, label: "Lista Suja", defaultName: "lista_suja" },
  { id: 36, label: "Porte", defaultName: "porte" },
  { id: 37, label: "Tempo Fundação", defaultName: "tempo_fundacao" },
  { id: 38, label: "Restritivos Cesta Financeira", defaultName: "restritivos_cesta_financeira" },
  { id: 39, label: "Restritivos Cesta Quantitativa", defaultName: "restritivos_cesta_quantitativa" },
  { id: 40, label: "Classificação Interna", defaultName: "classificacao_interna" },
  { id: 41, label: "Lucratividade", defaultName: "lucratividade" },
  { id: 42, label: "Dívida Líquida / EBITDA", defaultName: "divida_liquida_ebitda" },
  { id: 43, label: "Tempo Relacionamento", defaultName: "tempo_relacionamento" },
  { id: 44, label: "Tipo Cliente", defaultName: "tipo_cliente" },
  { id: 45, label: "Tempo Atividade", defaultName: "tempo_atividade" },
  { id: 46, label: "Tipo Propriedade", defaultName: "tipo_propriedade" },
  { id: 47, label: "Login", defaultName: "login" },
  { id: 48, label: "CNPJ ou CPF", defaultName: "cnpj_ou_cpf" },
  { id: 49, label: "Inadimplência", defaultName: "inadimplencia" },
  { id: 50, label: "Valor Solicitado", defaultName: "valor_solicitado" },
  { id: 51, label: "Parecer Comercial", defaultName: "parecer_comercial" },
  { id: 52, label: "Cap. Consumo Etanol", defaultName: "capacidade_consumo_etanol" },
  { id: 53, label: "Cap. Consumo Gasolina", defaultName: "capacidade_consumo_gasolina" },
  { id: 54, label: "Cap. Consumo Diesel", defaultName: "capacidade_consumo_diesel" },
  { id: 55, label: "Cap. Consumo Diesel S10", defaultName: "capacidade_consumo_diesel_s10" },
  { id: 56, label: "Tempo Cadastro Cliente", defaultName: "tempo_cadastro_como_cliente" },
  { id: 57, label: "Liquidez Imediata", defaultName: "liquidez_imediata" },
  { id: 58, label: "Preço Gasolina", defaultName: "preco_gasolina" },
  { id: 59, label: "Preço Diesel", defaultName: "preco_diesel" },
  { id: 60, label: "Preço Diesel S10", defaultName: "preco_diesel_s10" },
  { id: 61, label: "Preço Etanol", defaultName: "preco_etanol" },
  { id: 62, label: "Prazo Pagamento", defaultName: "prazo_pagamento" },
  { id: 63, label: "Score Interno", defaultName: "score_interno" },
  { id: 64, label: "Limite Interno", defaultName: "limite_interno" },
  { id: 65, label: "Classificação Executivo", defaultName: "classificacao_executivo" },
  { id: 66, label: "Venda Mês", defaultName: "venda_mes" },
  { id: 67, label: "Nome Assessor", defaultName: "nome_assessor" },
  { id: 68, label: "Despesas", defaultName: "despesas" },
  { id: 69, label: "Despesas Operacionais", defaultName: "despesas_operacionais" },
  { id: 71, label: "Disponível (Geral)", defaultName: "disponivel" },
  { id: 72, label: "Contas a Receber", defaultName: "contas_receber" },
  { id: 74, label: "Partes Relacionadas", defaultName: "partes_relacionadas" },
  { id: 75, label: "Contas a Receber (LP)", defaultName: "contas_receber_lp" },
  { id: 76, label: "Partes Relacionadas (LP)", defaultName: "partes_relacionadas_lp" },
  { id: 77, label: "Ativo Imobilizado", defaultName: "ativo_imobilizado" },
  { id: 78, label: "Ativo Intangível", defaultName: "ativo_intangivel" },
  { id: 79, label: "Investimentos", defaultName: "investimentos" },
  { id: 80, label: "Fornecedores", defaultName: "fornecedores" },
  { id: 81, label: "Empréstimos Bancários", defaultName: "empretimos_bancario" },
  { id: 82, label: "Salários e Impostos", defaultName: "salarios_impostos" },
  { id: 83, label: "Partes Relacionadas (Passivo)", defaultName: "partes_relacionadas_passivo" },
  { id: 84, label: "Fornecedores (LP)", defaultName: "fornecedores_lp" },
  { id: 85, label: "Empréstimos Bancários (LP)", defaultName: "emprestimos_bancarios_lp" },
  { id: 86, label: "Partes Relacionadas Passivo (LP)", defaultName: "partes_relacionadas_passivo_lp" },
  { id: 87, label: "Receita Bruta", defaultName: "receita_bruta" },
  { id: 88, label: "Deduções", defaultName: "deducoes" },
  { id: 90, label: "Outras Despesas Operacionais", defaultName: "outras_despesas_operacionais" },
  { id: 91, label: "Outras Receitas Operacionais", defaultName: "outras_receitas_operacionais" },
  { id: 92, label: "Despesas Financeiras (DRE)", defaultName: "despesas_financeiras_dre" },
  { id: 93, label: "Receitas Financeiras", defaultName: "receitas_financeiras" },
  { id: 94, label: "Receitas Não Operacionais", defaultName: "receitas_nao_operacionais" },
  { id: 95, label: "Despesas Não Operacionais", defaultName: "despesas_nao_operacionais" },
  { id: 96, label: "Impostos e Contribuições", defaultName: "impostos_contricuicoes" },
  { id: 98, label: "Outros Ativos Circulantes", defaultName: "outros_ativos_circulantes" },
  { id: 99, label: "Outros Ativos Não Circulantes", defaultName: "outros_ativos_nao_circulantes" },
  { id: 100, label: "Outros Passivos Circulantes", defaultName: "outros_passivos_circulantes" },
  { id: 101, label: "Outros Passivos Não Circulantes", defaultName: "outros_passivos_nao_circulantes" },
  { id: 102, label: "Despesas Operacionais (DRE)", defaultName: "despesas_operacionais_dre" },
  { id: 103, label: "Margem Bruta", defaultName: "margem_bruta" },
  { id: 104, label: "Margem Líquida", defaultName: "margem_liquida" },
  { id: 105, label: "Liquidez Seca", defaultName: "liquidez_seca" },
  { id: 106, label: "URL Site", defaultName: "url_site" },
  { id: 107, label: "Tipo de Análise", defaultName: "tipo_de_analise" },
  { id: 108, label: "Patrimônio Líquido (Indicador)", defaultName: "patrimonio_liquido_indicador" },
  { id: 109, label: "Comprometimento Renda", defaultName: "comprometimento_renda" },
  { id: 110, label: "Posto Atendimento", defaultName: "posto_atendimento" },
  { id: 111, label: "Tempo Cooperativa", defaultName: "tempo_cooperativa" },
  { id: 112, label: "Tipo Funcionário", defaultName: "tipo_funcionario" },
  { id: 113, label: "Score Boa Vista", defaultName: "score_boa_vista" },
  { id: 114, label: "Loja Alugada", defaultName: "loja_alugada" },
  { id: 115, label: "Número Funcionários", defaultName: "numero_funcionarios" },
  { id: 116, label: "Loja Nova", defaultName: "loja_nova" },
  { id: 117, label: "Nota Executivo", defaultName: "nota_executivo" },
  { id: 118, label: "Responsável Solidário", defaultName: "resp_solidario" },
  { id: 119, label: "Impostos a Recuperar", defaultName: "impostos_recuperar" },
  { id: 120, label: "Clientes", defaultName: "clientes" },
  { id: 121, label: "Adiantamento", defaultName: "adiatamento" },
  { id: 122, label: "Impostos a Recuperar (NC)", defaultName: "impostos_recuperar_nao_circulante" },
  { id: 123, label: "IR/CSLL Deferidos", defaultName: "ir_csll_deferidos" },
  { id: 124, label: "Depósitos Judiciais", defaultName: "depositos_judiciais" },
  { id: 125, label: "Reserva de Lucros", defaultName: "reserva_de_lucros" },
  { id: 126, label: "Reavaliação Patrimonial", defaultName: "reavaliacao_patrimonial" },
  { id: 127, label: "Outras Reservas PL", defaultName: "outras_reservas_patrimonio_liquido" },
  { id: 128, label: "Arrendamentos (NC)", defaultName: "arrendamentos_nao_circulante" },
  { id: 129, label: "Dividendos Passivo (NC)", defaultName: "dividendos_passivo_nao_circulante" },
  { id: 130, label: "Provisões (NC)", defaultName: "provisoes_nao_circulante" },
  { id: 131, label: "Dívidas Financeiras (NC)", defaultName: "dividas_financeiras_nao_circulante" },
  { id: 132, label: "Outras Contas a Pagar (NC)", defaultName: "outras_contas_a_pagar_nao_circulante" },
  { id: 133, label: "Provisões", defaultName: "provisoes" },
  { id: 134, label: "Obrigações Tributárias", defaultName: "obrigacoes_tributarias" },
  { id: 135, label: "Dividendos", defaultName: "dividendos" },
  { id: 136, label: "Arrendamentos (PC)", defaultName: "arrendamentos_passivo_circulante" },
  { id: 137, label: "Impostos Passivo (PC)", defaultName: "impostos_passivo_circulante" },
  { id: 138, label: "Lucro Líquido", defaultName: "lucro_liquido" },
  { id: 139, label: "Reserva Equiv. Patrimonial", defaultName: "reserva_equiv_patrimonial" },
  { id: 140, label: "Provisão IR/CSLL", defaultName: "provisao_ir_csll" },
  { id: 141, label: "Despesas Administrativas", defaultName: "despesas_administrativas" },
  { id: 142, label: "Depreciação (DRE)", defaultName: "depreciacao_dre" },
  { id: 143, label: "Instrumentos Financeiros", defaultName: "instrumentos_financeiros" },
  { id: 145, label: "Ajuste Patrimonial", defaultName: "ajuste_patrimonial" },
  { id: 146, label: "Ações Tesouraria", defaultName: "acoes_tesouraria" },
  { id: 147, label: "Lucro/Prejuízo Acumulado", defaultName: "lucro_prejuizo_acumulado" },
  { id: 148, label: "Outras Receitas", defaultName: "outras_receitas" },
  { id: 149, label: "Resultado Não Operacional", defaultName: "resultado_nao_operacional" },
  { id: 150, label: "Adiantamento Passivo", defaultName: "adiatamento_passivo" },
  { id: 151, label: "Depósitos Judiciais (Ativo)", defaultName: "depositos_judiciais_ativo" },
  { id: 152, label: "Adiantamento Ativo (NC)", defaultName: "adiantamento_ativo_nao_circulante" },
  { id: 153, label: "Aplicações Financeiras (NC)", defaultName: "aplicacoes_financeiras_ativo_nao_circulante" },
  { id: 154, label: "Estoque (NC)", defaultName: "estoque_ativo_nao_circulante" },
  { id: 155, label: "Partes Relacionadas (Ativo NC)", defaultName: "partes_relacionadas_ativo_nao_circulante" },
  { id: 156, label: "Fornecedores (Passivo NC)", defaultName: "fornecedores_passivo_nao_circulante" },
  { id: 157, label: "Adiantamento (Passivo NC)", defaultName: "adiantamento_passivo_nao_circulante" },
  { id: 158, label: "Receitas Deferidas", defaultName: "receitas_deferidas" },
  { id: 159, label: "Futuro Aumento Capital", defaultName: "futuro_aumento_capital" },
  { id: 160, label: "Ágio Aquisição", defaultName: "agio_aquisicao" },
  { id: 161, label: "Capital Social a Integralizar", defaultName: "capital_social_integralizar" },
  { id: 162, label: "Distribuição Lucro", defaultName: "distribuicao_lucro" },
  { id: 163, label: "Reservas Incentivo Fiscal", defaultName: "reservas_incentivo_fiscal" },
  { id: 164, label: "Outros Resultados", defaultName: "outra_resultados" },
  { id: 165, label: "Reserva Capital", defaultName: "reserva_capital" },
  { id: 166, label: "Reservas Legais", defaultName: "reservas_legais" },
  { id: 167, label: "Despesas Vendas", defaultName: "despesas_vendas" },
  { id: 168, label: "Outras Despesas", defaultName: "outras_despesas" },
  { id: 169, label: "Res. Não Operacional (DRE)", defaultName: "resultado_nao_operacioanl" },
  { id: 170, label: "Receitas Deferidas (NC)", defaultName: "receitas_deferidas_nao_circulante" },
  { id: 171, label: "Derivativo", defaultName: "derivativo" },
  { id: 172, label: "Direito de Uso", defaultName: "direito_uso" },
  { id: 173, label: "Derivativo (Ativo NC)", defaultName: "derivativo_ativo_nao_circulante" },
  { id: 174, label: "Impostos (Passivo NC)", defaultName: "impostos_passivo_nao_circulante" },
  { id: 175, label: "Obrigações Trabalhistas (NC)", defaultName: "obrigacoes_trabalhistas_passivo_nao_circulante" },
  { id: 176, label: "Instr. Financeiros (Passivo NC)", defaultName: "instrumentos_financeiros_passivo_nao_circulante" },
  { id: 177, label: "Instr. Financeiros (PC)", defaultName: "instrumentos_financeiros_passivo_circulante" },
  { id: 178, label: "Outras Despesas Não Oper.", defaultName: "outras_despesas_nao_operacionais" },
  { id: 179, label: "Imóveis a Comercializar", defaultName: "imoveis_comercializar" },
  { id: 180, label: "Ativo Biológico", defaultName: "ativo_biologico" },
  { id: 181, label: "Dividendos JCP", defaultName: "dividendos_jcp" },
  { id: 182, label: "Contratos Energia", defaultName: "contratos_energia" },
  { id: 183, label: "Ativos Contratuais", defaultName: "ativos_contratuais" },
  { id: 184, label: "Ativos Não Correntes", defaultName: "ativos_nao_correntes" },
  { id: 185, label: "Ativos Indenizáveis", defaultName: "ativos_indenizaveis" },
  { id: 186, label: "Ativos Financeiros Setoriais", defaultName: "ativos_financeiros_setoriais" },
  { id: 187, label: "Dividendos JCP (NC)", defaultName: "dividendos_jcp_nao_circulante" },
  { id: 188, label: "Contratos Energia (NC)", defaultName: "contratos_energia_nao_circulante" },
  { id: 189, label: "Ativos Contratuais (NC)", defaultName: "ativos_contratuais_nao_circulante" },
  { id: 190, label: "Contratos Energia (Passivo)", defaultName: "contratos_energia_passivo" },
  { id: 191, label: "Ativos Contratuais (Passivo)", defaultName: "ativos_contratuais_passivo" },
  { id: 192, label: "Comissões a Pagar", defaultName: "comissoes_pagar" },
  { id: 193, label: "Contratos Energia (Passivo NC)", defaultName: "contratos_energia_passivo_nao_circulante" },
  { id: 194, label: "Ativos Contratuais (Passivo NC)", defaultName: "ativos_contratuais_passivo_nao_circulante" },
  { id: 195, label: "Comissões a Pagar (NC)", defaultName: "comissoes_pagar_nao_circulante" },
  { id: 196, label: "Valor Justo Contrato Energia", defaultName: "valor_justo_contrato_energia" },
  { id: 197, label: "Passivo Financeiro Setorial", defaultName: "passivo_financeiro_setorial" },
  { id: 198, label: "Ativos Não Recorrentes", defaultName: "ativos_nao_recorrentes" },
  { id: 199, label: "Vlr Justo Contrato Energia (NC)", defaultName: "valor_justo_contrato_energia_nao_circulante" },
  { id: 200, label: "Ativos Não Recorrentes (NC)", defaultName: "ativos_nao_recorrentes_nao_circulante" },
  { id: 201, label: "Ativos Indenizáveis (NC)", defaultName: "ativos_indenizaveis_nao_circulante" },
  { id: 202, label: "Ativos Financ. Setoriais (NC)", defaultName: "ativos_financeiros_setoriais_nao_circulante" },
  { id: 203, label: "Vlr Justo Ctr Energia (Passivo)", defaultName: "valor_justo_contrato_energia_paassivo" },
  { id: 204, label: "Vlr Justo Ctr Energia (Pass. NC)", defaultName: "valor_justo_contrato_energia_paassivo_nao_circulante" },
  { id: 205, label: "Passivo Financ. Setorial (NC)", defaultName: "passivo_financeiro_setorial_nao_circulante" },
  { id: 206, label: "Ativo Biológico (NC)", defaultName: "ativo_biologico_no_circulante" },
  { id: 207, label: "Imóveis a Comercializar (NC)", defaultName: "imoveis_comercializar_nao_circulante" },
  { id: 208, label: "Último Crédito Concedido", defaultName: "ultimo_credito_concedido" },
  { id: 209, label: "Perfil Usuário", defaultName: "perfil_usuario" },
  { id: 210, label: "Percentual Embalagem", defaultName: "percentual_embalagem" },
  { id: 211, label: "Custo Médio Mensal", defaultName: "custo_medio_mensal" },
  { id: 212, label: "Valor Médio Comprado Trombini", defaultName: "valor_medio_comprado_trombini" },
  { id: 213, label: "Segmento", defaultName: "segmento" },
  { id: 214, label: "Segmento ID", defaultName: "segmento_id" },
  { id: 215, label: "Capacidade de Pagar Juros", defaultName: "capacidade_de_pagar_juros" },
  { id: 216, label: "Grau Alavancagem Financeira", defaultName: "grau_de_alavancagem_financeira" },
  { id: 217, label: "EBITDA", defaultName: "ebitda" },
  { id: 218, label: "Prazo de Pagamento", defaultName: "prazo_de_pagamento" },
  { id: 219, label: "Restritivos Refin", defaultName: "restritivos_refin" },
  { id: 220, label: "Margem EBITDA", defaultName: "margem_ebitda" },
  { id: 221, label: "Calc. Limite Representatividade", defaultName: "calcular_limite_representatividade" },
  { id: 237, label: "Protestos (Financeiro)", defaultName: "protestos_financeiro" },
  { id: 240, label: "Estabilidade Cadastral", defaultName: "estabilidade_cadastral" },
  { id: 241, label: "Exposição ao Risco", defaultName: "exposicao_ao_risco" },

  // Caso especial do Ano
  { id: null, label: "Ano de Exercício", defaultName: "ano" } 
];
